import React from 'react';
import Lottie from 'react-lottie';

import AnimationDoneLottie from 'src/animations/done.json';
import { Box } from 'src/components/Box';
import { zIndex } from 'src/utils/zIndex';

export const DoneAnimation = () => {
  return (
    <div data-qa="done-animation">
      <Box
        j="center"
        a="center"
        position="absolute"
        top={'0'}
        right={'0'}
        bottom={'0'}
        left={'0'}
        zIndex={zIndex.WebsiteAnimation}
      >
        <Box w={{ xs: 6, sm: 5, md: 3 }} h="100%">
          <Lottie
            options={{
              loop: false,
              autoplay: true,
              animationData: AnimationDoneLottie,
            }}
          />
        </Box>
      </Box>
    </div>
  );
};
